'use client';

import { c as _c } from "react/compiler-runtime";
import { Badge, CollapsibleTrigger, ItemContent, ItemMedia, ItemTitle, Tooltip, TooltipContent, TooltipTrigger } from '@repo/ui/components';
import { ChevronDown, ChevronRight, LucideIcon, TriangleAlert } from '@repo/ui/icons';
import Link from 'next/link';
import { ComponentProps, type ReactNode } from 'react';
export type DetailsItemSource = {
  href?: string;
  label: string;
  target?: ComponentProps<typeof Link>['target'];
  tooltip?: string;
  variant?: 'default' | 'destructive' | 'outline' | 'secondary';
};
export const DetailsItemHeader = t0 => {
  const $ = _c(21);
  const {
    collapsible,
    Icon,
    needsWarning,
    open,
    source,
    title
  } = t0;
  let t1;
  if ($[0] !== Icon) {
    t1 = Icon ? <ItemMedia className="translate-y-0! self-center!"><Icon className="size-5 text-muted-foreground" size={24} /></ItemMedia> : null;
    $[0] = Icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== needsWarning) {
    t2 = needsWarning && <TriangleAlert className="text-destructive" size={20} />;
    $[2] = needsWarning;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== source) {
    t3 = source && <Tooltip><TooltipTrigger render={<Badge className="ml-2 text-xs font-semibold" variant={source.variant ?? "secondary"} />}>{source.href ? <Link href={source.href} target={source.target}>{source.label}</Link> : source.label}</TooltipTrigger>{source.tooltip && <TooltipContent className="w-max max-w-72 text-balance">{source.tooltip}</TooltipContent>}</Tooltip>;
    $[4] = source;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== title) {
    t4 = <ItemTitle className="text-left text-2xl font-extrabold text-foreground" data-sentry-element="ItemTitle" data-sentry-source-file="details-item-header.tsx">{title}{t2}{t3}</ItemTitle>;
    $[6] = t2;
    $[7] = t3;
    $[8] = title;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== collapsible || $[11] !== open) {
    t5 = collapsible && (open ? <ChevronDown size={20} /> : <ChevronRight size={20} />);
    $[10] = collapsible;
    $[11] = open;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t5) {
    t6 = <span className="block">{t5}</span>;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t4 || $[16] !== t6) {
    t7 = <ItemContent className="flex-row items-center justify-between" data-sentry-element="ItemContent" data-sentry-source-file="details-item-header.tsx">{t4}{t6}</ItemContent>;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t1 || $[19] !== t7) {
    t8 = <CollapsibleTrigger className="flex flex-1 items-center gap-2" nativeButton={false} data-sentry-element="CollapsibleTrigger" data-sentry-component="DetailsItemHeader" data-sentry-source-file="details-item-header.tsx">{t1}{t7}</CollapsibleTrigger>;
    $[18] = t1;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};